
import Vue from "vue";
import { NewGatewaysApiFunc, setAccessToken } from "@/api";
import { Gateway, GatewayStatus } from "@/models";

import TheTemplate from "../components/TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";
import moment from "moment";
import BaseChuiGaki from "@/components/BaseChuiGaki.vue";

export type DataType = {
  gateway?: Gateway;
};

export default Vue.extend({
  name: "GatewayDeleteScreen",

  components: {
    BaseChuiGaki,
    TheTemplate,
    BaseCloseButton,
    BaseSubmitButton,
    BaseCancelButton,
  },

  data(): DataType {
    return {
      gateway: new Gateway(),
    };
  },

  computed: {
    companyNameText(): string {
      return this.$globalData.companyName || "";
    },

    gatewayMacAddressText(): string {
      return this.gateway?.mac || "";
    },

    gatewayStatusText(): string {
      switch (this.gateway?.details?.status) {
        case GatewayStatus.UNINITIALIZED:
          return "未初期化";
        case GatewayStatus.RUNNING:
          return "稼動";
        case GatewayStatus.SUSPENDED:
          return "停止";
        default:
          return "不明";
      }
    },

    statusClassText(): string {
      switch (this.gateway?.details?.status) {
        case GatewayStatus.UNINITIALIZED:
          return "red";
        case GatewayStatus.RUNNING:
          return "";
        case GatewayStatus.SUSPENDED:
          return "red";
        default:
          return "red";
      }
    },

    checkedTimingText(): string {
      if (!this.gateway?.details?.statusUpdatedTime) return "なし";
      return moment(this.gateway?.details?.statusUpdatedTime).format(
        "YYYY-MM-DD(HH:mm:ss)"
      );
    },
  },

  mounted() {
    this.getGateway();
  },

  methods: {
    async getGateway(): Promise<void> {
      const companyId = this.$router.currentRoute.params.companyId;
      const gatewayId = this.$router.currentRoute.params.gatewayId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewGatewaysApiFunc().adminGetGateway(
        companyId,
        gatewayId
      );

      if (err != null) {
        this.$handleApiError(err, this.getGateway);
        return;
      }

      this.gateway = data;
    },

    async unassignGateway(): Promise<void> {
      this.$setLoading(true);

      const companyId = this.$router.currentRoute.params.companyId;
      const gatewayId = this.$router.currentRoute.params.gatewayId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewGatewaysApiFunc().adminUnassignGateway(
        companyId,
        gatewayId
      );

      if (err != null) {
        this.$handleApiError(err, this.unassignGateway);
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-gateways",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
